import React from 'react';
import './LobbyFactionArt.css';
import {LoadedImage} from '../../EmblaCarousel/FactionsCarousel';
import SkinRankMark from '../../SkinRankMark/SkinRankMark';
import {RANDOM_FACTION_ID} from '../../../configs/factions';

/**
 * Полный арт фракции (со скином) в десктопном лобби: плитки, карусель,
 * сетка «Все фракции». Картинка проявляется по загрузке (LoadedImage) и
 * заполняет опору целиком (object-fit: cover) — размер задает вызывающий.
 *
 * Рейтинговый образ (withFrame и есть рамка лиги) — как в «Моей коллекции»:
 * арт во всю опору, а рамка обнимает ее снаружи и выступает за нее (см.
 * LobbyFactionArt.css) — место под выступ оставляет вызывающий. Края арта
 * растворяются маской, под ним — фон цвета лиги, как в карусели скинов:
 * иначе пестрый арт сливался бы с такой же пестрой рамкой.
 *
 * Эффект «выбрано» (flash) — свечение цветом фракции и короткий пульс; ключ
 * свечения — момент выбора, чтобы повторный выбор перезапускал анимацию.
 *
 * @param {Object} props
 * @param {Object} props.display - getLobbyFactionDisplay
 * @param {string} [props.className]
 * @param {boolean} [props.withFrame]
 * @param {boolean} [props.isIcon] - иконка образа вместо полного арта
 *   (компактная сетка — как в «Моей коллекции»)
 * @param {number|null} [props.flashAt] - момент выбора этой фракции (эффект «выбрано»)
 */
const LobbyFactionArt = ({display, className = '', withFrame = false, isIcon = false, flashAt = null}) => {
  const imagePath = (isIcon && display.iconPath) || display.imagePath;
  const isFramed = withFrame && Boolean(display.framePath);
  const rootClassName = [
    'lobby-faction-art',
    isFramed ? 'lobby-faction-art_framed' : '',
    // Бюст «Случайной» — прозрачная картинка, а не арт во всю плитку: где
    // поверх идет подпись, его уменьшают (см. LobbyFactionGrid.css)
    display.factionId === RANDOM_FACTION_ID ? 'lobby-faction-art_random' : '',
    flashAt ? 'lobby-faction-art_flash' : '',
    className,
  ].filter(Boolean).join(' ');

  // key — по картинке: сменился скин или фракция — новая картинка заново
  // проявляется, а не подменяет старую мгновенно
  const image = (
    <LoadedImage
      key={imagePath}
      className="lobby-faction-art_img"
      src={imagePath}
      alt={display.name}
    />
  );

  return (
    <div className={rootClassName} style={{'--lobby-faction-color': display.textColor}}>
      {isFramed ? (
        <>
          <div className="lobby-faction-art_window" style={{backgroundColor: display.frameBackgroundColor || undefined}}>
            {image}
          </div>
          <img className="lobby-faction-art_frame" src={display.framePath} alt="" aria-hidden="true"/>
        </>
      ) : image}
      <SkinRankMark skinRank={display.skinRank} className="lobby-faction-art_skin-rank"/>
      {flashAt && <span key={flashAt} className="lobby-faction-art_flash-glow" aria-hidden="true"/>}
    </div>
  );
};

export default LobbyFactionArt;
